var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerrainSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,2H5C3.3457031,2,2,3.3457031,2,5v22c0,1.6542969,1.3457031,3,3,3h22c1.6542969,0,3-1.3457031,3-3V5 C30,3.3457031,28.6542969,2,27,2z M24,7c0,1.6259766-0.9160156,3-2,3s-2-1.3740234-2-3s0.9160156-3,2-3S24,5.3740234,24,7z M5,28 c-0.5517578,0-1-0.4482422-1-1V8c1.1025391,0,2,0.8974609,2,2v7c0,4.9628906,4.0371094,9,9,9h7c1.1025391,0,2,0.8974609,2,2H5z  M27,28h-1c0-2.2060547-1.7939453-4-4-4h-7c-3.859375,0-7-3.140625-7-7v-7c0-2.2060547-1.7939453-4-4-4V5 c0-0.5517578,0.4482422-1,1-1h5v6c0,6.6171875,5.3828125,12,12,12h6v5C28,27.5517578,27.5517578,28,27,28z M28,20h-6 c-5.5136719,0-10-4.4863281-10-10V4h2v4c0,4.4111328,3.5888672,8,8,8c2.3900757,0,4.5327759-1.0591431,6-2.7262573V20z M22,14 c-3.3085938,0-6-2.6914062-6-6V4h2.8203125C18.3127441,4.8382568,18,5.8700562,18,7c0,2.7568359,1.7939453,5,4,5s4-2.2431641,4-5 c0-1.1299438-0.3127441-2.1617432-0.8203125-3H27c0.5517578,0,1,0.4482422,1,1v3C28,11.3085938,25.3085938,14,22,14z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerrainSmall);
export default __webpack_public_path__ + "static/media/terrain--small.b8864873e69aca9d69733feb11d70d37.svg";
export { ForwardRef as ReactComponent };